import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrint = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3343_3758)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.298 10.7695H12.1827C12.4326 10.7695 12.6723 10.6702 12.849 10.4935C13.0257 10.3168 13.125 10.0771 13.125 9.82721V5.58684C13.125 5.33692 13.0257 5.09724 12.849 4.92053C12.6723 4.74381 12.4326 4.64453 12.1827 4.64453H1.8173C1.56739 4.64453 1.32771 4.74381 1.15099 4.92053C0.974278 5.09724 0.875 5.33692 0.875 5.58684V9.82721C0.875 10.0771 0.974278 10.3168 1.15099 10.4935C1.32771 10.6702 1.56739 10.7695 1.8173 10.7695H3.70191",
				stroke: "#002E5F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.7019 9.35547V12.6535C3.7019 12.7785 3.75154 12.8983 3.8399 12.9867C3.92826 13.075 4.0481 13.1247 4.17306 13.1247H9.82689C9.95184 13.1247 10.0717 13.075 10.16 12.9867C10.2484 12.8983 10.298 12.7785 10.298 12.6535V9.35547H3.7019Z",
				stroke: "#002E5F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.298 4.64422V1.34615C10.298 1.2212 10.2484 1.10136 10.16 1.013C10.0717 0.924639 9.95184 0.875 9.82689 0.875H4.17306C4.0481 0.875 3.92826 0.924639 3.8399 1.013C3.75154 1.10136 3.7019 1.2212 3.7019 1.34615V4.64422",
				stroke: "#002E5F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.7692 7H9.8269",
				stroke: "#002E5F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3343_3758",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgPrint);
export default ForwardRef;
